import { Autocomplete, FormHelperText, InputLabel, TextField, Typography } from '@mui/material';
import { IFormController } from '../types';
import React from 'react';

const AutoCompleteTags = (props: IFormController) => {
  const { label, name, formik, required, description, placeholder, options = [], ...rest } = props;
  
  const [value, setValue] = React.useState(
    props.formik?.initialValues?.[props.name]
      ? props.formik?.initialValues?.[props.name]
      : []
  );

  React.useEffect(() => {
    if (options.length > 0) {
      setValue(options);
      formik?.setFieldValue(name, options);
      formik?.setFieldTouched(name, true);
    } 
  }, [options]);

  const onChange = (name: string, value: string[]) => {
    formik?.setFieldValue(name, [...new Set(value)]);
    setValue([...new Set(value)]);
    formik?.setFieldTouched(name, true);
  };
  return (
    <>
      <InputLabel
        disabled={props.disabled}
        htmlFor='autocomplete-chips-name'
        required={required}
        sx={{
          my: 2,
          textAlign: 'left',
          textStyle: 'none',
        }}
      >
        {label}
      </InputLabel>
      <FormHelperText>
        <Typography variant='subtitle1'>
          {description}
        </Typography>
      </FormHelperText>
      <Autocomplete
        id={name}
        fullWidth
        multiple
        disablePortal
        filterSelectedOptions
        value={props?.formik?.values[props.name]
          ? value
          : []}
        options={options || []}
        freeSolo
        onChange={(_, value) => onChange(name, value)}
        {...rest}
        renderInput={(params) => (
          <TextField
            sx={{ paddingRight: '30px' }}
            placeholder={placeholder}
            {...params}
            inputProps={{ ...params.inputProps }}
          />
        )}
      />
    </>
  );
};

export default AutoCompleteTags;